export const diaporama_vue = 0;
export const vue = 1;
export const graphe = 2;
